export default "__VITE_ASSET__BC87hryS__"